import React from 'react';
import { View, Text, ScrollView, StyleSheet, TouchableOpacity, Alert } from 'react-native';
import { Card, Title, Paragraph } from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import TopClientesCard from '../../components/score/TopClientesCard';
import BaixaPontualidadeCard from '../../components/score/BaixaPontualidadeCard';

const ScoreIndicator = ({ score, label }) => {
  let color = '#FF4136'; // Vermelho para score baixo
  let description = 'Baixa';

  if (score >= 80) {
    color = '#2ECC40'; // Verde para score alto
    description = 'Alta';
  } else if (score >= 50) {
    color = '#FF851B'; // Laranja para score médio
    description = 'Média';
  }

  return (
    <View style={styles.scoreIndicatorContainer}>
      <View style={[styles.scoreCircle, { backgroundColor: color }]}>
        <Text style={styles.scoreText}>{score}%</Text>
      </View>
      <Text style={styles.scoreDescription}>{label}: {description}</Text>
      <Text style={styles.scoreLegend}>
        {label === 'Pontualidade' && score >= 80 && 'Acima de 80%'}
        {label === 'Pontualidade' && score >= 50 && score < 80 && 'Entre 80% e 50%'}
        {label === 'Pontualidade' && score < 50 && 'Abaixo de 50%'}
      </Text>
    </View>
  );
};

const ScoreScreen = ({ navigation }) => {
  return (
    <ScrollView style={styles.container}>
      <Text style={styles.title}>Score de Clientes</Text>
      
      <View style={styles.dashboardContainer}>
        <Card style={styles.dashboardCard}>
          <Card.Content>
            <Title>Visão Geral de Score</Title>
            <View style={styles.dashboardRow}>
              <ScoreIndicator score={80} label="Pontualidade" />
              <ScoreIndicator score={50} label="Pontualidade" />
              <ScoreIndicator score={40} label="Pontualidade" />
            </View>
          </Card.Content>
        </Card>
      </View>
      
      <View style={styles.cardSection}>
        <Text style={styles.sectionTitle}>Melhores Clientes</Text>
        <TopClientesCard />
      </View>
      
      <View style={styles.cardSection}>
        <Text style={styles.sectionTitle}>Clientes com Baixa Pontualidade</Text>
        <BaixaPontualidadeCard />
      </View>
      
      <TouchableOpacity 
        style={styles.listaButton}
        onPress={() => navigation.navigate('Clientes')}
      >
        <Text style={styles.listaButtonText}>Ver Lista Completa de Clientes</Text>
      </TouchableOpacity>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f4f4f4'
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    marginVertical: 20
  },
  dashboardContainer: {
    marginBottom: 20,
    paddingHorizontal: 10
  },
  dashboardCard: {
    elevation: 3
  },
  dashboardRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10
  },
  scoreIndicatorContainer: {
    alignItems: 'center',
    width: '30%'
  },
  scoreCircle: {
    width: 80,
    height: 80,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10
  },
  scoreText: {
    color: 'white',
    fontSize: 18,
    fontWeight: 'bold'
  },
  scoreDescription: {
    fontSize: 12,
    textAlign: 'center'
  },
  scoreLegend: {
    fontSize: 10,
    textAlign: 'center',
    color: '#666',
    marginTop: 5
  },
  cardSection: {
    marginBottom: 20,
    paddingHorizontal: 10
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
    paddingHorizontal: 10
  },
  listaButton: {
    backgroundColor: '#007bff',
    padding: 15,
    borderRadius: 10,
    alignItems: 'center',
    marginHorizontal: 20,
    marginBottom: 20
  },
  listaButtonText: {
    color: 'white',
    fontWeight: 'bold'
  }
});

export default ScoreScreen;
